'use strict';

import controller from './ampliacion.controller';
import template from './ampliacion.html';

const AmpliacionComponent = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default AmpliacionComponent;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/ampliacion/ampliacion.component.js